<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<div v-if="xiazai" style="background: #00fff0;padding: 4px 0;width: 130px; margin-bottom: 10px; text-align: center;cursor: pointer; " @click="xiazaia">Sailing Report</div>
			<!-- <li>
				<span>80、Date of sailing report</span>
				<div style="display: flex;" v-if="dataList.sc001">
					<img :src="item" v-for="(item, index) in dataList.sc001.split('|')" />
				</div>

			</li> -->

			<li>
				<span>80、Date of sailing report</span>
				<span>{{ dataList.jz080 }}</span>
			</li>
			<li>
				<span>82、Date of the previous daily report</span>
				<span>{{ dataList.jz082 }}</span>
			</li>
			<li>
				<span>83、Description of cargo condition(For example:1.All the cargo was stacked in warehouse with coverage.2.Scratched on the surface slightly, affected all3.Rust on the surface slightly, affected all1~2 pcs strapping bands broken/missing, affected 41 bundles）</span>
				<span>{{ dataList.jz083 }}</span>
			</li>
			<li>
				<span>84、Date of loading commenced</span>
				<span>{{ dataList.jz084 }}</span>
			</li>
			<li>
				<span>85、Loading completed date</span>
				<span>{{ dataList.jz085 }}</span>
			</li>
			<li>
				<span>86、Qantity of operation lines (eg:3 gangs of stevedore)</span>
				<span>{{ dataList.jz086 }}</span>
			</li>

			<li>
				<span>87、Quantity of cranes used in loading operation</span>
				<span>{{ dataList.jz087 }}</span>
			</li>
			<li>
				<span>88、Kind of crane lifted cargo(For example:shore crane)</span>
				<span>{{ dataList.jz088 }}</span>
			</li>
			<li>
				<span>89、Number of cargo hold for loading (For example:No.4 ect)</span>
				<span>{{ dataList.jz089 }}</span>
			</li>
			<li>
				<span>90、Lashing and secure operation(For example:The lashing gang used the belly band (W x T: 32 x 0.9mm) for lashing steel coils. The top tier coil was lashed by belly bands along transverse direction and cross lashed with low tier. )</span>
				<span>{{ dataList.jz090 }}</span>
			</li>
			<li>
				<span>91、Stowage Condition(For example:The loading operation for above-mentioned cargo was completed at 2115LT on 6 Jun 2011, total 229 coils / 2998.480MT of cargo shipped on board.In hold No.1: 98 coils were loaded in 10 rows totally from fore part to aft part. In hold No.2: 131 coils were loaded in 12 rows totally from fore part to aft part. Among them all coils were loaded in 2 tiers high.In hold, all steel coils would be stowed in hold No.1.2 on top tank as per stowage plan.1 shore crane was used to load the cargoes in hold all time.)</span>
				<span>{{ dataList.jz091 }}</span>
			</li>
			<li>
				<span>92、Total quantity loaded onboard(For example:229 coils)</span>
				<span>{{ dataList.jz092 }}</span>
			</li>
			<li>
				<span>93、Total weight of cargo loaded onboard(For example: 2998.48MT)</span>
				<span>{{ dataList.jz093 }}</span>
			</li>
			<li>
				<span>94、The time and date of lashing operation completed (For example:2200hrs on 6-Jun-2011)</span>
				<span>{{ dataList.jz094 }}</span>
			</li>
			<li>
				<span>95、The time and date of loading operation completed(For example:2200hrs on 6-Jun-2011))</span>
				<span>{{ dataList.jz095 }}</span>
			</li>
			<li>
				<span>96、Quantity and weight in each cargo hold</span>
				<div v-for="(item,index) in dataList.AtScheduleNewJz096List">
					<ul class="li12">
						<li>
							Hold No.:{{item.jz09601}}
						</li>
						<li>
							Description of cargo:{{item.jz09602}}
						</li>
						<li>
							B/L No.:{{item.jz09603}}
						</li>
						<li>
							Packages:{{item.jz09604}}
						</li>
						<li>
							Weight(Mt）:{{item.jz09605}}
						</li>
					</ul>
				</div>
			</li>

			<li>
				<span>97、Description of cargo(Non-must fill)</span>
				<span v-if="dataList.jz097=='nothing'">{{ dataList.jz097 }}</span>
				<ul v-else class="li12">
					<li>
						1、The steel deformed bars were stored {{dataList.jz09701}} {{dataList.jz0970101}} coverage.
					</li>
					<li>
						2、Strapping bands rusty or not
						<div v-if="dataList.jz09702=='Yes'">
							Strapping steel bands/wires for bundles of steel deformed bars were rusty {{dataList.jz0970201}} and {{dataList.jz0970202}} affected {{dataList.jz0970203}} bundles.
						</div>
						<div v-else>
							{{dataList.jz0970201}}
						</div>
					</li>
					<li>
						3、Whether the surface scratched or not
						<div v-if="dataList.jz09703=='Yes'">
							The steel deformed bars scratched surface {{dataList.jz0970301}} and {{dataList.jz0970302}} , affected {{dataList.jz0970303}}  bundles.
						</div>
						<div v-else>
							{{dataList.jz0970301}}
						</div>
					</li>
					<li>
						4、Whether the surface of cargo is rusty or not
						<div v-if="dataList.jz09704=='Yes'">
						The steel deformed bars were rusty on the surface, affected {{dataList.jz0970401}} bundles.
						</div>
						<div v-else>
							{{dataList.jz0970401}}
						</div>
					</li>
					<li>
						5、Whether the steel strapping bands were broken /loosen or not
						<div v-if="dataList.jz09705=='Yes'">
							The strapping bands of steel deformed bars were broken off or loosen, affect {{dataList.jz0970501}} bundles.
						</div>
						<div v-else>
							{{dataList.jz0970501}}
						</div>
					</li>
					<li>
						6、Whether the end is bent or not
						<div v-if="dataList.jz09706=='Yes'">
							The end of {{dataList.jz0970601}} pcs of steel deformed bars in bundles were found bent  partly, affect {{dataList.jz0970602}} bundles.
						</div>
						<div v-else>
							{{dataList.jz0970601}}
						</div>
					</li>
					<li>
						7、Delivered quantity as per {{dataList.jz0970701}}, {{dataList.jz0970702}} quality/weight/ volume as per shipper, specification unknown;
					</li>
					<li>
						Additional remarks (Non-must fill)
						{{dataList.jz09708}}
					</li>
				</ul>
			</li>
			<li>
				<span>98、Description of cargo (Non-must fill)</span>
				<span v-if="dataList.jz098=='nothing'">{{ dataList.jz098 }}</span>
				<ul v-else class="li12">
					<li>
						1、The wire rods were stored {{dataList.jz09801}} {{dataList.jz0980101}}  coverage  before shipment.
					</li>
					<li>
						2、Strapping bands rusty or not
						<div v-if="dataList.jz09802=='Yes'">

							Strapping steel bands/wires were rusty partly, affected  {{dataList.jz0980201}} and {{dataList.jz0980202}} coils.
						</div>
						<div v-else>
							{{dataList.jz0980201}}
						</div>
					</li>
					<li>
						3、Whether the surface scratched or not
						<div v-if="dataList.jz09803=='Yes'">
							The steel wire rods scratched surface {{dataList.jz0980301}} and {{dataList.jz0980302}} , affected {{dataList.jz0980303}}  coils.
						</div>
						<div v-else>
							{{dataList.jz0980301}}
						</div>
					</li>
					<li>
						4、Whether the surface of cargo is rusty or not
						<div v-if="dataList.jz09804=='Yes'">

						The steel wire rods were rusty on the surface, affected {{dataList.jz0980401}} coils.
						</div>
						<div v-else>
							{{dataList.jz0980401}}
						</div>
					</li>
					<li>
						5、Whether the steel strapping bands were broken/loosen or not
						<div v-if="dataList.jz09805=='Yes'">
							The steel wire rods strapping bands were broken off or loosen, affect  {{dataList.jz0980501}} coils.
						</div>
						<div v-else>
							{{dataList.jz0980501}}
						</div>
					</li>
					<li>
						6、Whether the surface is deformed or not
						<div v-if="dataList.jz09806=='Yes'">
							   The coils of wire rod were found deformed {{dataList.jz0980601}}  affect {{dataList.jz0980602}} coils.
						</div>
						<div v-else>
							{{dataList.jz0980601}}
						</div>
					</li>
					<li>
						7、Whether the surface is winding or not
						<div v-if="dataList.jz09807=='Yes'">
							The steel wire rods were winding twist {{dataList.jz0980701}} and {{dataList.jz0980702}}  affect {{dataList.jz0980702}} coils.
						</div>
						<div v-else>
							{{dataList.jz0980701}}
						</div>
					</li>
					<li>
						8、Delivered quantity as per {{dataList.jz0980801}}, {{dataList.jz0980802}} quality/weight/ volume as per shipper, specification unknown;
					</li>
					<li>
						Additional remarks (Non-must fill)
						{{dataList.jz09809}}
					</li>
				</ul>
			</li>

			<li>
				<span>99、Description of cargo (Non-must fill)</span>
				<span v-if="dataList.jz099=='nothing'">{{ dataList.jz099 }}</span>
				<ul v-else class="li12">
					<li>
						1、Stored {{dataList.jz09901}} {{dataList.jz0990101}} coverage.
					</li>
					<li>
						2、Strapping bands rusty or not
						<div v-if="dataList.jz09902=='Yes'">
							Rusty at surface {{dataList.jz0990201}} affects {{dataList.jz0970202}} pcs
						</div>
						<div v-else>
							{{dataList.jz0990201}}
						</div>
					</li>
					<li>
						3、Please enter:Quantity of steel plates were wet or not
						<div v-if="dataList.jz09903=='Yes'">
							Plates were wet {{dataList.jz0990301}}  before shipment,   affected {{dataList.jz0990302}} pcs
						</div>
						<div v-else>
							{{dataList.jz0990301}}
						</div>
					</li>
					<li>
						4、Whether the steel plates were dent or not
						<div v-if="dataList.jz09904=='Yes'">
						{{dataList.jz0970401}} pcs dent {{dataList.jz0970402}} on the edge.
						</div>
						<div v-else>
							{{dataList.jz0990401}}
						</div>
					</li>
					<li>
						5、Whether steel plates scored on edge and surface or not
						<div v-if="dataList.jz09905=='Yes'">
							Scored on edge and surface {{dataList.jz0990501}} and {{dataList.jz0990502}} ，affected {{dataList.jz0990503}} pcs
						</div>
						<div v-else>
							{{dataList.jz0990501}}
						</div>
					</li>
					<!-- <li>
						6、Whether the end is bent or not
						<div v-if="dataList.jz09706=='Yes'">
							The end of {{dataList.jz0970601}} pcs of steel deformed bars in bundles were found bent  partly, affect {{dataList.jz0970602}} bundles.
						</div>
						<div v-else>
							{{dataList.jz0970601}}
						</div>
					</li> -->
					<li>

						7、Delivered quantity as per {{dataList.jz0990701}}, {{dataList.jz0970702}} quality/weight/ volume as per shipper, specification unknown;
					</li>
					<li>
						Additional remarks (Non-must fill)
						{{dataList.jz09908}}
					</li>
				</ul>
			</li>

			<li>
				<span>100、Description of cargo (Non-must fill)</span>
				<span v-if="dataList.jz100=='nothing'">{{ dataList.jz100 }}</span>
				<ul v-else class="li12">
					<li>
						1、stored {{dataList.jz10001}} {{dataList.jz1000101}}   coverage  before shipment.
					</li>
					<li>
						2、Strapping bands rusty or not
						<div v-if="dataList.jz10002=='Yes'">
							visible surfaces of steel sheet in coils and strapping bands rust and dust stained，affected {{dataList.jz1000201}} coils.
						</div>
						<div v-else>
							{{dataList.jz1000201}}
						</div>
					</li>
					<li>
						3、Whether the surface of the steel coil scratched or not
						<div v-if="dataList.jz10003=='Yes'">
							scratched/scored/chafed/dented on external packing surface/edges {{dataList.jz1000301}} and {{dataList.jz1000302}} , affected {{dataList.jz1000303}}  pcs.
						</div>
						<div v-else>
							{{dataList.jz1000301}}
						</div>
					</li>
					<li>
						4、Whether the strapping bands of coils broken/lost or not
						<div v-if="dataList.jz10004=='Yes'">

						{{dataList.jz1000401}} coils strapping bands broken/missing , sffected {{dataList.jz1000402}} coils.
						</div>
						<div v-else>
							{{dataList.jz1000401}}
						</div>
					</li>
					<li>
						5、Whether protective ring torn open or not
						<div v-if="dataList.jz10005=='Yes'">
							coils’s packing edge of outer circumference torn open before shipment, inner packing visible, affected {{dataList.jz1000501}} coils.
						</div>
						<div v-else>
							{{dataList.jz1000501}}
						</div>
					</li>
					<li>
						6、Whether the outer packaging torn or not
						<div v-if="dataList.jz10006=='Yes'">
							   the packing of coils were torn  {{dataList.jz1000601}}  affected {{dataList.jz1000602}} coils.
						</div>
						<div v-else>
							{{dataList.jz1000601}}
						</div>
					</li>
					<li>
						7、Whether outer packaging of steel coils corrugated or not
						<div v-if="dataList.jz10007=='Yes'">
							the packing corrugated {{dataList.jz1000701}} affected {{dataList.jz1000702}}  coils.
						</div>
						<div v-else>
							{{dataList.jz1000701}}
						</div>
					</li>
					<li>
						8、Delivered quantity as per {{dataList.jz1000801}}, {{dataList.jz1000802}} quality/weight/ volume as per shipper, specification unknown;
					</li>
					<li>
						Additional remarks (Non-must fill)
						{{dataList.jz10009}}
					</li>
				</ul>
			</li>

			<li>
				<span>101、Description of cargo (Non-must fill)</span>
				<span v-if="dataList.jz101=='nothing'">{{ dataList.jz101 }}</span>
				<ul v-else class="li12">
					<li>
						1、stored {{dataList.jz10101}} {{dataList.jz1010101}}  coverage  before shipment.
					</li>
					<li>
						2、Whether surface of steel coils rusted or not
						<div v-if="dataList.jz10102=='Yes'">
							Please enter：Quantity of steel coils which surface rusted {{dataList.jz1010201}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010201}}
						</div>
					</li>
					<li>
						3、Whether surface of strapping bands for steel coils rusted or not
						<div v-if="dataList.jz10103=='Yes'">
							Strapping bands rusty, affected {{dataList.jz1010301}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010301}}
						</div>
					</li>
					<li>
						4、Whether oil spots on surface or not
						<div v-if="dataList.jz10104=='Yes'">

						Oil stained on surface {{dataList.jz1010401}}, affected {{dataList.jz1010402}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010401}}
						</div>
					</li>
					<li>
						5、Whether scratched/dent on edge and surafce or not
						<div v-if="dataList.jz10105=='Yes'">
							Scratched/scored on surface/edges {{dataList.jz1010501}} and {{dataList.jz1010502}}, affected {{dataList.jz1010503}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010501}}
						</div>
					</li>
					<li>
						6、Whether stapping bands of coils broken/lost or not
						<div v-if="dataList.jz10106=='Yes'">
							   {{dataList.jz1010601}} coils strapping bands broken/missing, affected {{dataList.jz1010602}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010601}}
						</div>
					</li>
					<li>
						7、Whether the edge of windings buckled or not
						<div v-if="dataList.jz10107=='Yes'">
							Inner and/or outer (or both) edges of windings locally/slightly buckled/torn where handling gear marked, affected  {{dataList.jz1010701}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010701}}
						</div>
					</li>
					<li>
						8、Whether the coils telescoped or not
						<div v-if="dataList.jz10108=='Yes'">
							The range of telescoped {{dataList.jz1010801}}, affected {{dataList.jz1010802}} coils.
						</div>
						<div v-else>
							{{dataList.jz1010801}}
						</div>
					</li>

					<li>
						9、Delivered quantity as per {{dataList.jz1010901}}, {{dataList.jz1010902}} quality/weight/ volume as per shipper, specification unknown;
					</li>
					<li>
						Additional remarks (Non-must fill)
						{{dataList.jz10110}}
					</li>
				</ul>
			</li>
			<li>
				<span>102、"Steel Cargo- other" (cargo condition description)(Non-must fill)</span>
				<span v-if="dataList.jz102=='nothing'">{{ dataList.jz102 }}</span>
				<ul v-else class="li12">
					<li>
						Addinional remarks (Non-must fill)
					</li>
					<li>
						{{ dataList.jz10201 }}
					</li>
				</ul>
			</li>
			<li>
				<span>103、SHIP’S REMARK:(For example:All cargo are (quantity) checked by China TallyCargo condition is checked by P&I surveyor and as per cargo condition. )</span>
				<span>{{ dataList.jz103 }}</span>

			</li>
			<li>
				<span>104、Other information, (Working time reference and weather condition during loading operation)(For example:1.Berth alongside: at 1600LT on November 23, 2015.2.Commenced the loading work: at 1915LT on November 23, 20153.Suspended to loading due raining: at 0045~0340LT on November 24,20154.Suspended to loading due raining: 1150LT on November 24 ~0450LT on Nov 25, 20155.Hold No.4 completed loading: at 2001LT on November 25, 20156.Hold No.4 resume loading: at 1745LT on November 26, 20157.Temperature and weather on November 23, 2015 : 14℃~18℃, shower8.Temperature and weather on November 24, 2015 : 1℃~8℃, shower）</span>
				<span>{{ dataList.jz104 }}</span>

			</li>
			<li>
				<span>105、Sailing time （For example:0800hrs on 7-Jun-2011）</span>
				<span>{{ dataList.jz105 }}</span>

			</li>
			<li>
				<span>106、 Photoes of Vessel's condition before shipment</span>
				<div style="display: flex;" v-if="dataList.jz106">
					<img :src="item" v-for="(item, index) in dataList.jz106.split('|')" />
				</div>

			</li>
			<li>
				<span>19、Photo of the cargo condition before loading</span>
				<div style="display: flex;" v-if="dataList.jz19">
					<img :src="item" v-for="(item, index) in dataList.jz19.split('|')" />
				</div>

			</li>
			<li>
				<span>20、Photoes of loading operation</span>
				<div style="display: flex;" v-if="dataList.jz20">
					<img :src="item" v-for="(item, index) in dataList.jz20.split('|')" />
				</div>

			</li>
			<li>
				<span>123、  Photoes of dunnage</span>
				<div style="display: flex;" v-if="dataList.jz123">
					<img :src="item" v-for="(item, index) in dataList.jz123.split('|')" />
				</div>

			</li>
			<li>
				<span>129、Photoes of lashing</span>
				<div style="display: flex;" v-if="dataList.jz129">
					<img :src="item" v-for="(item, index) in dataList.jz129.split('|')" />
				</div>

			</li>
			<li>
				<span>124、Cargo stowage condition in cargo hold</span>
				<div style="display: flex;" v-if="dataList.jz124">
					<img :src="item" v-for="(item, index) in dataList.jz124.split('|')" />
				</div>

			</li>
			<li>
				<span>107、</span>
				<ul class="li12" v-for="(item,index) in dataList.AtScheduleNewJz107List">
					<li>
						S/O NO.（例：VL2016ZMBS011C-）:{{item.jz10701}}
					</li>
					<li>
						{{item.jz10702}}
					</li>
					<li>
						Quantity（例：60 Coils）:{{item.jz10703}}
					</li>
				</ul>

			</li>
			<li>
				<span>81、Signature of the surveyor/inspector</span>
				<div style="display: flex;" v-if="dataList.jz81">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz81.split('|')" />
				</div>

			</li>
			<li>
				<span>79、Name of the tally company</span>
				<span>{{ dataList.jz79 }}</span>
			</li>

		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'sc',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: '',
			id:'',
			kid:'',
			xiazai:false
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.xiazai = this.$route.query.xiazai;
			this.getSchedulesc();
		}
	},
	methods: {
		xiazaia(){
			window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + this.kid + '.pdf')
		},
		getSchedulesc() {
			let data = {
				id: this.id
			};
			this.$api.khb(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.dataList = res.data;
					this.kid=res.data.id
					// if(!this.xiazai){
					// 	window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + res.data.id + '.pdf')
					// }
					// if (res.data.sc1010) {
					// 	if (this.getSuffix(res.data.sc1010) == 'pdf') {
					// 		this.num = 1;
					// 	} else {
					// 		this.num = 0;
					// 	}
					// }
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		}
	}
};
</script>

<style lang="scss" scoped>
	.li12 li{color: #fff !important;}
	.li12 div{color: #fff !important;}
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
